import React, { useState, useEffect } from "react";
import axios from "axios";
import { showSuccess } from "services/toast.service";
import { handleError, getAccessToken } from "utils";
import { useHistory, useLocation } from "react-router-dom";
import Button from "components/Button";
import { ALL_ROLES } from "config/roles";
import { API_BASE_URL } from "config/constants";
import Modal from "react-modal";
import { getUser } from "utils";

const AddClients = ({ color }) => {
  const history = useHistory();

  const [modalIsOpen, setIsOpen] = useState(false);
  const [assignTo, setAssignTo] = useState("");
  const [manager, setmanager] = useState([]);
  const { pathname, state } = useLocation();
  const { data } = state || {};
  const [isClientActive, setIsClientActive] = useState(data?.isActive);
  const user = getUser();

  const isUpdate = pathname === "/admin/update-client";
  useEffect(() => {
    setIsClientActive(data?.isActive);
  }, [data]);
  if (isUpdate && !data) {
    history.goBack();
  }
  const [gettingData, setGettingData] = useState(false);

  const [submitClick, setSubmitClick] = useState(false);
  const [loading, setLoading] = useState(false);
  const [client, setclient] = useState(
    data || {
      name: "",
      email: "",
      phone: "",
      password: "",
      role: "",
      skype: "",
      website: "",
      companyName: "",
      assignedTo: "",
    }
  );

  const onChange = (e) => {
    setclient({ ...client, [e.target.name]: e.target.value });
  };

  const onChangeAssignTo = (e) => {
    setAssignTo(e.target.value);
  };

  const isValid = () => {
    if (
      !client.name ||
      !client.email ||
      !client.phone ||
      !client.password ||
      !client.role ||
      !client.skype
    )
      return false;

    if (
      !(client.role === "Account Manager") &&
      (!client.website || !client.companyName)
    )
      return false;
    return true;
  };

  const handleClick = () => {
    setSubmitClick(true);
    if (!isValid()) return;
    if (isUpdate) {
      updateClient(client);
    } else {
      addClient(
        client.name,
        client.email,
        client.phone,
        client.password,
        client.role,
        client.skype,
        client.website,
        client.companyName
      );
    }
  };

  const getManagers = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/user/all_account_managers`,
        {
          method: "GET",
          headers: {
            authorization: getAccessToken(),
          },
        }
      );
      const apiData = response.data;
      setmanager(apiData.result.data);
      console.log("all account managers ", apiData, apiData.result.data);
    } catch (error) {
      setGettingData(false);
      handleError(error);
    }
  };

  useEffect(() => {
    getManagers();
    // getAllAccountManagers();
  }, []);

  const handleClickApprove = async () => {
    if (assignTo) {
      const assign = JSON.parse(assignTo);
      console.log('assign is ', assign);
      await axios
        .post(
          API_BASE_URL + "/user/approve",
          {
            id: data._id,
            assignedTo: assign.name,
            assignedToId: assign._id,
          },
          {
            headers: {
              authorization: getAccessToken(),
            },
          }
        )
        .then((result) => {
          console.log("assigned successfully ", result);
          setIsOpen(false);
          showSuccess(result?.data?.result?.message);
          setIsClientActive(true);
        });
    }
  };

  const addClient = async (
    name,
    email,
    phone,
    password,
    role,
    skype,
    website,
    companyName
  ) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/user`,
        {
          name,
          email,
          phone,
          password,
          role,
          skype,
          website,
          companyName,
        },
        {
          headers: {
            authorization: getAccessToken(),
          },
        }
      );

      setLoading(false);
      showSuccess(response?.data?.result?.message);
      history.push("/admin/client");
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const updateClient = async (dataToUpdate) => {
    try {
      setLoading(true);
      console.log("id is ", data);
      const response = await axios.put(`${API_BASE_URL}/client`, {
        ...dataToUpdate,
        id: data._id,
      },  {
        headers: {
          "Content-Type": "application/json",
          authorization: getAccessToken(),
        },
      });
      setLoading(false);
      showSuccess(response?.data?.result?.message);
      history.push("/admin/client");
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const customStyles = {
    content: {
      top: "40%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };
  const modal = () => {
    setIsOpen((current) => !current);
  };
  function closeModal() {
    console.log("close click");
    setIsOpen(false);
  }

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
        <div className="rounded-t bg-white mb-0 px-6 py-6">
          <div className="text-center flex justify-between">
            <h6 className="text-blueGray-700 text-xl font-bold">
              {isUpdate ? "Update Client" : "Add New Client"}
              <span className="text-blueGray-700 text-sm font-bold">
                {" "}
                (Fill in the details below)
              </span>
            </h6>
            {isUpdate && !isClientActive ? (
              <>
                <button
                  className="bg-orange-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={modal}
                >
                  Approve
                </button>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="flex-auto px-4 py-10 pt-0">
          <form>
            <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase px-4">
              Client Information
            </h6>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Name
                  </label>
                  <input
                    type="text"
                    value={client.name}
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    defaultValue=""
                    name="name"
                    onChange={onChange}
                  />
                  {submitClick && !client.name && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Name is required!
                    </div>
                  )}
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    value={client.email}
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    defaultValue=""
                    name="email"
                    onChange={onChange}
                  />
                  {submitClick && !client.email && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Email is required!
                    </div>
                  )}
                </div>
              </div>

              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Phone
                  </label>
                  <input
                    type="text"
                    value={client.phone}
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    defaultValue=""
                    name="phone"
                    onChange={onChange}
                  />
                  {submitClick && !client.phone && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Phone is required!
                    </div>
                  )}
                </div>
              </div>

              {!isUpdate && (
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Password
                    </label>
                    <input
                      type="password"
                      value={client.password}
                      autoComplete="new-password"
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      defaultValue=""
                      name="password"
                      onChange={onChange}
                    />
                    {submitClick && !client.password && (
                      <div className="text-red-500 text-sm mt-1 font-semibold">
                        Password is required!
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Role
                  </label>
                  <select
                    value={client.role}
                    disabled={isUpdate}
                    onChange={onChange}
                    name="role"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  >
                    <option value="">Choose Role</option>
                    {ALL_ROLES.filter((r) => r.display).filter((r) => r.role.includes(user.role)).map((r, index) => (
                      <option key={index} value={r.value}>
                        {r.name}
                      </option>
                    ))}
                  </select>

                  {submitClick && !client.role && (
                    <div className="text-red-500 text-sm mt-1 font-semibold">
                      Role is required!
                    </div>
                  )}
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Skype
                  </label>
                  <input
                    type="text"
                    value={client.skype}
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="skype"
                    onChange={onChange}
                  />
                </div>
              </div>

              {!(client.role === "Account Manager") && (
                <>
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label
                        className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                        htmlFor="grid-password"
                      >
                        Website
                      </label>
                      <input
                        type="text"
                        value={client.website}
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        name="website"
                        onChange={onChange}
                      />
                      {submitClick && !client.website && (
                        <div className="text-red-500 text-sm mt-1 font-semibold">
                          Website is required!
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label
                        className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                        htmlFor="grid-password"
                      >
                        Company
                      </label>
                      <input
                        type="text"
                        value={client.companyName}
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        name="companyName"
                        onChange={onChange}
                      />
                      {submitClick && !client.companyName && (
                        <div className="text-red-500 text-sm mt-1 font-semibold">
                          Company is required!
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="px-4">
              <Button
                title={isUpdate ? "UPDATE CLIENT" : "ADD NEW CLIENT"}
                handleClick={handleClick}
                loading={loading}
              />
            </div>
          </form>
          <div>
            <Modal
              isOpen={modalIsOpen}
              style={customStyles}
              shouldCloseOnEsc
              contentLabel="Example Modal"
            >
              <i
                className="fa fa-times-circle absolute top-2 right-1 cursor-pointer"
                style={{
                  right: 18,
                  top: 18,
                  width: 20,
                  height: 20,
                  zIndex: 100,
                }}
                onClick={closeModal}
              ></i>
              <div className=" relative rounded-t mb-0 px-4 py-3 border-0 ">
                <div className="flex flex-wrap items-center">
                  <div className="relative flex justify-items-start gap-2 items-center w-full px-6 max-w-full flex-grow flex-1">
                    {" "}
                    <h3
                      className={
                        "font-semibold text-xl  " +
                        (color === "light" ? "text-blueGray-700" : "text-black")
                      }
                    >
                      Need for Approval
                    </h3>
                  </div>
                </div>
              </div>
              <div className="w-full lg:w-6/20 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-3"
                    htmlFor="grid-password"
                  >
                    Assigned To
                  </label>
                  {manager && manager[0] && (
                    <select
                      onChange={onChangeAssignTo}
                      name="role"
                      value={assignTo}
                      className="border-0 mt-1 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    >
                      <option value={""}>
                          Choose account manager..
                        </option>
                      {manager.map((item, key) => (
                        <option key={key} value={JSON.stringify(item)}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  )}
                  <button
                    className=" mt-5 bg-yellow-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={handleClickApprove}
                  >
                    Approve
                  </button>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddClients;
